import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../../@core/components/core-sidebar/core-sidebar.service';
import {AlertService} from '../../../shared/services/alert.service';
import {HttpClient} from '@angular/common/http';
import {GlobalService} from '../../../shared/services/global.service';
import {CategoryService} from '../../../shared/services/category.service';
import {CourseService} from '../../../shared/services/course.service';
import {UniversityService} from '../../../shared/services/university.service';
import {LectureService} from '../../../shared/services/lecture.service';

@Component({
    selector: 'app-add-lecture',
    templateUrl: './add-lecture.component.html',
    styleUrls: ['./add-lecture.component.scss']
})
export class AddLectureComponent implements OnInit {
    addLectureForm: FormGroup;
    id: any;
    category: any;
    universities: any = [];
    courses: any = [];
    semesters: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    videoFileId: any;
    submitted: any = false;
    submitting: any = false;
    uploadingVideo: boolean = false;
    @Output() valueSubmitted = new EventEmitter<any>();
    @Input() data: any;
    onFileChanged: any;
    uploadedVideoUrl: string | null = null;

    constructor(private _coreSidebarService: CoreSidebarService,
                private fb: FormBuilder,
                private alertService: AlertService,
                public http: HttpClient,
                public globalService: GlobalService,
                public categoryService: CategoryService,
                private lectureService: LectureService,
                private universityService: UniversityService,
                private courseService: CourseService) {
    }

    ngOnInit(): void {
    }

    ngOnChanges(): void {
        this.refresh();
        this.getCategory();
        this.getUniversities();
        this.getCourses();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-lecture').toggleOpen();
    }

    getCategory() {
        this.category = [];
        const params = {};
        this.categoryService.get(params).subscribe(res => {
            if (res && res['data']) {
                this.category = res['data'];
            }
        }, error => {
            this.category = [];
        });
    }

    getUniversities() {
        this.universities = [];
        const params = {};
        this.universityService.get(params).subscribe(res => {
            if (res && res['data']) {
                this.universities = res['data'];
            }
        }, error => {
            this.universities = [];
        });
    }

    getCourses() {
        this.courses = [];
        const params = {};
        this.courseService.get(params).subscribe(res => {
            if (res && res['data']) {
                this.courses = res['data'];
            }
        }, error => {
            this.courses = [];
        });
    }

    refresh() {
        this.addLectureForm = this.fb.group({
            'name': ['', Validators.required],
            'category_id': ['', Validators.required],
            'university_id': ['', Validators.required],
            'course_id': ['', Validators.required],
            'semester': ['', Validators.required],
        });
        if (this.data && this.data['id']) {
            this.patchForm();
        }
    }

    patchForm() {
        this.addLectureForm.patchValue({
            'name': this.data?.name || '',
            'category_id': this.data?.category_id || '',
            'university_id': this.data?.university_id || '',
            'course_id': this.data?.course_id || '',
            'semester': this.data?.semester || '',
        });
        if (this.data?.video_file_data?.url) {
            this.uploadedVideoUrl = this.data.video_file_data.url;
            this.videoFileId = this.data.video_file_data.id;
        }
    }

    submit() {
        this.submitted = true;
        if (!this.addLectureForm.valid) {
            return;
        }
        if (!this.videoFileId) {
            this.alertService.showErrors('Video Required');
        }
        if (this.submitted) {
            const params = {
                'name': (this.addLectureForm.value && this.addLectureForm.value.name) ? this.addLectureForm.value.name : '',
                'category_id': (this.addLectureForm.value && this.addLectureForm.value.category_id) ? this.addLectureForm.value.category_id : '',
                'university_id': (this.addLectureForm.value && this.addLectureForm.value.university_id) ? this.addLectureForm.value.university_id : '',
                'course_id': (this.addLectureForm.value && this.addLectureForm.value.course_id) ? this.addLectureForm.value.course_id : '',
                'semester': (this.addLectureForm.value && this.addLectureForm.value.semester) ? this.addLectureForm.value.semester : '',
                'video_file_id': this.videoFileId
            };
            this.submitting = true;
            this.lectureService.create(params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.valueSubmitted.emit(true);
                    this.addLectureForm.reset();
                    this.addLectureForm.patchValue({
                        'name': '',
                        'category_id': '',
                        'university_id': '',
                        'course_id': '',
                        'semester': '',
                    });
                    this.uploadedVideoUrl = null;
                    this.videoFileId = null;
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                }
            });
        }
    }

    update() {
        this.submitted = true;
        if (!this.addLectureForm.valid) {
            return;
        }
        if (!this.videoFileId) {
            this.alertService.showErrors('Video Required');
        }
        if (this.submitted) {
            const params = {
                'name': (this.addLectureForm.value && this.addLectureForm.value.name) ? this.addLectureForm.value.name : '',
                'category_id': (this.addLectureForm.value && this.addLectureForm.value.category_id) ? this.addLectureForm.value.category_id : '',
                'university_id': (this.addLectureForm.value && this.addLectureForm.value.university_id) ? this.addLectureForm.value.university_id : '',
                'course_id': (this.addLectureForm.value && this.addLectureForm.value.course_id) ? this.addLectureForm.value.course_id : '',
                'semester': (this.addLectureForm.value && this.addLectureForm.value.semester) ? this.addLectureForm.value.semester : '',
                'video_file_id': this.videoFileId
            };
            this.submitting = true;
            this.lectureService.update(this.data['unique_id'], params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.valueSubmitted.emit(true);
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                }
            });
        }
    }

    onVideoFileChange(event: any, type: string): void {
        this.onFileChanged = event;
        this.uploadingVideo = true;
        this.lectureService.fileUpload({
            'type': type,
            'fileType': 'NORMAL',
            'category_id': this.addLectureForm.value?.category_id || '',
        }, this.onFileChanged).subscribe(res => {
            if (res && res['data']) {
                this.videoFileId = res['data']['id'] || null;
                this.uploadedVideoUrl = res['data']['url'] || null;
            }
            this.uploadingVideo = false;
            this.alertService.showSuccess({
                title: 'Success',
                message: 'Uploaded Successfully'
            });
        }, error => {
            this.uploadingVideo = false;
            this.alertService.showErrors('Something went wrong, please try again');
        });
    }

    openUploadedVideo() {
        if (this.uploadedVideoUrl) {
            window.open(this.uploadedVideoUrl, '_blank');
        }
    }
}
